import { SVGProps } from './SVGProps';

const LinkedIn = ({ fill = 'white', width = '18', height = '18' }: SVGProps) => {
  return (
    // <svg width={width} height={height} viewBox="0 0 258 258" fill="none" xmlns="http://www.w3.org/2000/svg">
    //   <path
    //     d="M74.605 53.75C74.6021 59.4522 72.3342 64.9196 68.3002 68.9497C64.2661 72.9797 58.7964 75.2421 53.0942 75.2393C47.3921 75.2364 41.9246 72.9685 37.8946 68.9345C33.8646 64.9004 31.6021 59.4307 31.605 53.7285C31.6078 48.0264 33.8757 42.5589 37.9098 38.5289C41.9438 34.4988 47.4136 32.2364 53.1157 32.2393C58.8179 32.2421 64.2854 34.51 68.3154 38.5441C72.3454 42.5781 74.6078 48.0479 74.605 53.75ZM75.25 91.16H32.25V225.75H75.25V91.16ZM143.19 91.16H100.405V225.75H142.76V155.123C142.76 115.778 194.037 112.123 194.037 155.123V225.75H236.5V140.503C236.5 74.175 160.605 76.6475 142.76 109.22L143.19 91.16Z"
    //     fill={fill}
    //   />
    // </svg>
    <svg width={width} height={height} viewBox="0 0 448 512" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M416 32H31.9C14.3 32 0 46.5 0 64.3V447.7C0 465.5 14.3 480 31.9 480H416C433.6 480 448 465.5 448 447.7V64.3C448 46.5 433.6 32 416 32ZM135.4 416H69V202.2H135.5V416H135.4ZM102.2 173C80.9 173 63.7 155.7 63.7 134.5C63.7 113.3 80.9 96 102.2 96C123.4 96 140.7 113.3 140.7 134.5C140.7 155.8 123.5 173 102.2 173ZM384.3 416H317.9V312C317.9 287.2 317.4 255.3 283.4 255.3C248.8 255.3 243.5 282.3 243.5 310.2V416H177.1V202.2H240.8V231.4H241.7C250.6 214.6 272.3 196.9 304.6 196.9C371.8 196.9 384.3 241.2 384.3 298.8V416Z"
        fill={fill}
      />
    </svg>
  );
};

export default LinkedIn;
